import React, { useState, useEffect, useContext } from 'react';
import {
  Drawer, IconButton, Dialog,
  DialogTitle, DialogContent, DialogContentText,
  TextField, DialogActions, Button
} from '@mui/material';
import SettingsIcon from '@mui/icons-material/Settings';
import QueueIcon from '@mui/icons-material/Queue';
import { navbarHeight } from '../../config';
import { MapContext } from '../MapContext';
import { CatalogContext } from '../CatalogContext';
import FullGeneList from './FullGeneList';
import GeneGroupDialog from './GeneGroupDialog';
import '../Topmenu.css';

const GeneListDrawer = ({ isOpen, onClose }) => {

  const { map } = useContext(MapContext);
  const { catalog } = useContext(CatalogContext);

  const [settingsDialogOpen, setSettingsDialogOpen] = useState(false);
  const [groupDialogOpen, setGroupDialogOpen] = useState(false);
  const [geneCountFile, setGeneCountFile] = useState('');
  const [genePMTilesLocation, setGenePMTilesLocation] = useState('');
  const [geneList, setGeneList] = useState([]);

  const fetchGeneList = async () => {
    try {
      if (geneCountFile == '') return;
      const res = await fetch(geneCountFile);
      const rawData = await res.json();
      const obj = rawData['count']['cnt_total'];
      const data = Object.entries(obj).map(
        ([key, value]) => ({ 'gene': key, 'count': value })
      );
      setGeneList(data);
    } catch (error){
      console.log("Error loading fetching gene list:", error)
    }
  }

  useEffect(() => {
    fetchGeneList();
  }, [geneCountFile]);

  useEffect(() => {
    setGeneCountFile(catalog?.assets.sge.stat || '');
  }, [catalog]);

  useEffect(() => {
    setGenePMTilesLocation(catalog?.assets.sge.perGene || '');
  }, [catalog]);

  return (
    <>
      <Drawer
        anchor="right"
        open={isOpen}
        onClose={onClose}
        variant="persistent"
        PaperProps={{
          style: {
            top: navbarHeight,
          },
        }}
        className='topmenu-drawer'
      >
        <div className='topmenu-top'>
          <IconButton onClick={() => setGroupDialogOpen(true)}>
            <QueueIcon />
            <span className="add-gene-group-text">Gene Group</span>
          </IconButton>
          <IconButton
            onClick={() => setSettingsDialogOpen(true)}
          >
            <SettingsIcon />
          </IconButton>
        </div>
        {isOpen ?
          <div className='topmenu-content'>
            <FullGeneList
              map={map}
              genePMTilesLocation={genePMTilesLocation}
              catalogId={catalog?.id}
              geneList={geneList}
            />
          </div>
          : <></>}
      </Drawer>

      <Dialog open={settingsDialogOpen} onClose={() => setSettingsDialogOpen(false)}>
        <DialogTitle>Settings</DialogTitle>
        <DialogContent>
          <TextField
            fullWidth
            margin="dense"
            label="Gene Count File"
            value={geneCountFile}
            onChange={(e) => setGeneCountFile(e.target.value)}
          />
          <TextField
            fullWidth
            margin="dense"
            label="Gene PMTiles Location"
            value={genePMTilesLocation}
            onChange={(e) => setGenePMTilesLocation(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSettingsDialogOpen(false)} color="primary">
            Cancel
          </Button>
          <Button onClick={() => {
            setSettingsDialogOpen(false);
          }} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog open={groupDialogOpen} onClose={() => setGroupDialogOpen(false)}>
        <DialogTitle>Gene Group</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Select gene from the list with the help of auto-complete. Pasting from clipboard is also supported.
          </DialogContentText>
          <GeneGroupDialog
            map={map}
            genePMTilesLocation={genePMTilesLocation}
            catalogId={catalog?.id}
            geneList={geneList}
            handleCloseGeneGroupDialog={() => {
              setGroupDialogOpen(false);
            }}
          />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default GeneListDrawer;

